import { useContext } from 'react';
import { Context, getRollbarFromContext } from './Provider.js';
import './_rollupPluginBabelHelpers-e84dd01a.js';
import 'rollbar';
import './tiny-invariant.esm-a43f84cc.js';

function useRollbar() {
  var context = useContext(Context);
  return getRollbarFromContext(context);
}

export { useRollbar };